export function getAppWithEntryPointsFactory(customGroupForm) {
  return (application) => {
    return customGroupForm.appsWithEntryPoints.find(
      (appWithEntryPoints) => appWithEntryPoints.application === application
    );
  };
}
